export class DistributionColumn {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "string",
            "format": ""
        },
        {
            "name": "unit",
            "baseName": "unit",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "HealthStatus",
            "format": ""
        },
        {
            "name": "kind",
            "baseName": "kind",
            "type": "DistributionKind",
            "format": ""
        },
        {
            "name": "note",
            "baseName": "note",
            "type": "string",
            "format": ""
        },
        {
            "name": "numeric",
            "baseName": "numeric",
            "type": "NumericDistribution",
            "format": ""
        },
        {
            "name": "_enum",
            "baseName": "_enum",
            "type": "EnumDistribution",
            "format": ""
        },
        {
            "name": "tracked",
            "baseName": "tracked",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "currentNullRate",
            "baseName": "currentNullRate",
            "type": "number",
            "format": "double"
        },
        {
            "name": "nullCount",
            "baseName": "nullCount",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "valueCount",
            "baseName": "valueCount",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "icebergMin",
            "baseName": "icebergMin",
            "type": "number",
            "format": "double"
        },
        {
            "name": "icebergMax",
            "baseName": "icebergMax",
            "type": "number",
            "format": "double"
        },
        {
            "name": "distinctCount",
            "baseName": "distinctCount",
            "type": "number",
            "format": "double"
        },
        {
            "name": "critical",
            "baseName": "critical",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "role",
            "baseName": "role",
            "type": "ColumnRole",
            "format": ""
        },
        {
            "name": "slo",
            "baseName": "slo",
            "type": "number",
            "format": "double"
        },
        {
            "name": "history",
            "baseName": "history",
            "type": "Array<number>",
            "format": "double"
        }
    ];
    static getAttributeTypeMap() {
        return DistributionColumn.attributeTypeMap;
    }
    constructor() {
    }
}
